import React from 'react';

import ExpLabel from '@exp/components/localization/ExpLabel';

import teaser1 from '../images/teaser3.svg';
import teaser2 from '../images/teaser2.svg';
import teaser3 from '../images/teaser1.svg';
import { noop } from '../utilities/utilities';

type AccountTeaserProps = {
  activeSlide?: number;
  className?: string;
  onClick?: () => void;
  setActiveSlide?: (slide: number) => void;
};

const AccountTeaser = ({
  activeSlide = 0,
  className = '',
  onClick = noop,
  setActiveSlide = noop,
}: AccountTeaserProps) => (
  <>
    <ul className={`teasers ${className}`} onClick={onClick}>
      <li className={activeSlide === 0 ? 'active' : undefined}>
        <img alt="" src={teaser1} />
        <ExpLabel
          defaultMessage="Explore deals from hundreds of brands"
          messageKey="onb.backdrop.initial.teaser1"
          tagName="p"
        />
      </li>
      <li className={activeSlide === 1 ? 'active' : undefined}>
        <img alt="" src={teaser2} />
        <ExpLabel
          defaultMessage="Learn from brands with optional education"
          messageKey="onb.backdrop.initial.teaser2"
          tagName="p"
        />
      </li>
      <li className={activeSlide === 2 ? 'active' : undefined}>
        <img alt="" src={teaser3} />
        <ExpLabel
          defaultMessage="Enjoy up to 60% off premium products"
          messageKey="onb.backdrop.initial.teaser3"
          tagName="p"
        />
      </li>
    </ul>
    <ul className="dots">
      <li
        className={activeSlide === 0 ? 'active' : undefined}
        onClick={() => {
          setActiveSlide(0);
        }}
      />
      <li
        className={activeSlide === 1 ? 'active' : undefined}
        onClick={() => {
          setActiveSlide(1);
        }}
      />
      <li
        className={activeSlide === 2 ? 'active' : undefined}
        onClick={() => {
          setActiveSlide(2);
        }}
      />
    </ul>
  </>
);

AccountTeaser.displayName = 'AccountTeaser';

export default AccountTeaser;
